import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

// Typed shape returned by the (parallel ONNAECBackend task) getAccount Lambda /
// accepted by updateAccount. Keep field names in sync with that task.
export interface Account {
    email: string;
    username: string;
    domain: string;
    displayName: string;
}

export interface AccountState {
    account: Account | null;
}

const initialState: AccountState = {
    account: null
};

export const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {
        setAccount: (state, action: PayloadAction<Account>) => {
            state.account = action.payload;
        },
        updateDisplayName: (state, action: PayloadAction<string>) => {
            if (state.account) {
                state.account.displayName = action.payload;
            }
        }
    }
});

export const { setAccount, updateDisplayName } = accountSlice.actions;

export const currentAccount = (state: RootState) => state.account.account;

export default accountSlice.reducer;
